import { render } from "./editComponent.vue?vue&type=template&id=3703926e"
import script from "./editComponent.vue?vue&type=script&lang=js"
export * from "./editComponent.vue?vue&type=script&lang=js"

import "./editComponent.vue?vue&type=style&index=0&id=3703926e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__